<template>
  <q-page class="adicon-font-1">
    <div class="row justify-center">
      <div class="col-lg-7 col-md-8 col-sm-10 col-xs-11">
        <q-card v-for="vacant in vacantsList" class="q-my-lg card-shadow">
          <q-card-section>
            <div class="text-h6">{{ vacant.name }}</div>
          </q-card-section>
          <q-separator />
          <q-card-section>{{ vacant.description }}</q-card-section>
          <q-card-section>
            <q-btn
              label="Ver mas"
              flat
              color="deep-orange-7"
              no-caps
              rounded
              @click="seeMoreVacant(vacant)"
            />
            <a
              :href="`mailto:vacantes@amradvisors.com.pa?subject=${vacant.name}`"
            >
              <q-btn
                label="Aplicar"
                rounded
                no-caps
                color="cyan-8"
                unelevated
                flat
                class="q-ml-md"
              />
            </a>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <q-dialog
      v-model="vacantModal"
      maximized
      transition-show="slide-up"
      transition-hide="slide-down"
    >
      <q-card class="bg-cyan-8 text-white adicon-font-1">
        <q-bar>
          <q-space />

          <q-btn dense flat icon="close" v-close-popup>
            <q-tooltip class="bg-white text-cyan-8">Cerrar</q-tooltip>
          </q-btn>
        </q-bar>
        <q-card-section>
          <div class="row justify-center">
            <div class="col-lg-7 col-md-8 col-sm-10 col-xs-11">
              <div class="text-h5 q-my-md text-weight-bolder">
                {{ selectedVacant?.name }}
              </div>
              <q-separator class="q-mb-md" color="white" />
              <div class="text-subtitle1 q-mb-md">
                {{ selectedVacant?.description }}
              </div>
              <div class="text-h6 text-bold">
                <u>Funciones</u>
              </div>
              <div class="text-body1" v-for="funct in vacancyFunctions">
                {{ funct }}
              </div>
              <div class="text-h6 text-bold q-mt-md">
                <u>Requisitos</u>
              </div>
              <div class="text-body1" v-for="req in vacancyRequirements">
                {{ req }}
              </div>
              <div class="text-h6 text-bold q-mt-md">
                <u>Habilidades</u>
              </div>
              <div class="text-body1" v-for="skill in vacancySkills">
                {{ skill }}
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script lang="ts" setup>
import { GoogleSpreadsheet } from "google-spreadsheet";
import { ref, onMounted, computed } from "vue";

interface Vacant {
  name: string;
  description: string;
  functions: string[];
  requirements: string[];
  skills: string;
  color: number;
}

const vacantsList = ref<Vacant[]>([]);
const selectedVacant = ref<Vacant>();
const vacantModal = ref(false);

const seeMoreVacant = (vacant: Vacant) => {
  selectedVacant.value = vacant;
  vacantModal.value = true;
};

const vacancyFunctions = computed(() =>
  selectedVacant.value?.functions[0].split("\n")
);

const vacancyRequirements = computed(() =>
  selectedVacant.value?.requirements[0].split("\n")
);

const vacancySkills = computed(() => selectedVacant.value?.skills.split("\n"));

onMounted(async () => {
  const doc = new GoogleSpreadsheet(
    "1nv0WbFZLqSopn_dfprlHkPaHaj523P5-W_QSMzsc24w",
    { apiKey: "AIzaSyB62kWNPR7ApeDQ6heA2n1GIhDeQwDQHZU" }
  );

  await doc.loadInfo();

  const sheet = doc.sheetsByIndex[0];

  let rows = await sheet.getRows();
  let step = 1;
  rows.forEach((row) => {
    if (step > 3) step = 1;
    const vacant: Vacant = {
      name: row.get("nombre"),
      description: row.get("descripcion"),
      functions: row.get("funciones").split(";"),
      requirements: row.get("requisitos").split(";"),
      skills: row.get("competencias"),
      color: step,
    };
    vacantsList.value.push(vacant);
    step++;
  });
});
</script>

<style scoped>
.card-shadow {
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
</style>
